import type GetGlobalDataResult from '../models/GetGlobalDataResult';
import GlobalDataStorageFactory from '../factories/GlobalDataStorageFactory';
import { Result } from '@/core/models/Result';

export default class StoreGlobalDataUseCase {
    private globalDataStorageRepo = GlobalDataStorageFactory.makeRepo();

    public invoke(model: GetGlobalDataResult) {
        const result = new Result<unknown>();

        this.globalDataStorageRepo.setIsFetchError(false);
        this.globalDataStorageRepo.setIsTooManyRequests(model.customResponseCode === 'too_many_requests');

        this.globalDataStorageRepo.setCustomerSourceId(model.customerSourceId);
        this.globalDataStorageRepo.setQrDiscountPercent(model.qrDiscountPercent ?? model.data?.qrDiscountPercent ?? 0);
        this.globalDataStorageRepo.setCustomerInfo(model.data?.customerInfo || null);
        this.globalDataStorageRepo.setProducts(model.data?.products || []);
        if (model.customResponseCode === 'livestream_session_expired') {
            this.globalDataStorageRepo.setIsLivestreamSessionExpired(true);
        } else if (model.success === true) {
            this.globalDataStorageRepo.setIsLivestreamSessionExpired(false);
        }
        this.globalDataStorageRepo.markAsFetchedData();

        result.success = true;
        return result;
    }
}
